"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (editorState) {
  var selection = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var blockStartKey = selection.getStartKey();

  return contentState.getBlockMap().get(blockStartKey);
};


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src023959432/src/github.com/GipsyBot/gipsy-webapp/node_modules/draft-js-list-depth-plugin/lib/utils/getSelectedBlock.js
// module id = 964
// module chunks = 0